import { useNavigate } from "react-router-dom"
import MTable from "../../../components/mtable"
import { getStorage, STORAGE } from "../../../utils/storage"

export default function Tracks() {

    const navigate = useNavigate()
    const isAdmin = getStorage(STORAGE.IS_ADMIN)
    const isCM = getStorage(STORAGE.USER_ROLE) === 'CompanyManager'
    const canCreate = isAdmin || isCM
    const create = () => navigate('create')
    const details = (track) => {
        // In-progress "Build a Track" drafts have no materialized chapters yet — resume the wizard.
        if (track.isDraftInProgress) navigate(`build/${track.id}`)
        else if (isCM && track.status !== 'Published') navigate(`edit/${track.id}`)
        else navigate(track.id)
    }

    const tracksMapper = {columns: [
        {
            label: "Name",
            value: (item) => item.name
        },
        {
            label: "Display Name",
            value: (item) => item.displayName
        },
        {
            label: "Status",
            value: (item) => item.isDraftInProgress ? "Draft (setup in progress)" : item.status
        }
    ]}

    return(<div className="page-xl-centered standard-padding showing">
        <div className="flex space-between gap-xs v-spacer-m">
            <p className="section-title">Tracks</p>
            {canCreate && <div className="flex center gap-xs">
                {isAdmin
                    ? <button className="solid with-icon leading" onClick={() => navigate('build')}>
                        <span className="material-symbols-outlined scale-xs">auto_awesome</span>
                        <span>Create Track</span>
                    </button>
                    : <button className="solid" onClick={create}>Create Track</button>}
            </div>}
        </div>
        <MTable path={'tracks'} mapper={tracksMapper} onClick={details}/>
    </div>)
}